var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainPage"},[_c('div',{staticClass:"mainPageContent"},[_c('div',{staticClass:"contentPanel"},[_vm._m(0),_c('div',{staticClass:"textCenter info1"},[_c('div',[_vm._v("Startup Parameters:")]),_c('div',{staticClass:"textnormal"},[_vm._v(" "+_vm._s(_vm.startupParameters)+" ")])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")])])
}]

export { render, staticRenderFns }